/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Processing_Event_GroupInputs */

const en_ateliere_connect_status_processing_event_group = /** @type {(inputs: Ateliere_Connect_Status_Processing_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing Event Group...`)
};

const fr_ateliere_connect_status_processing_event_group = /** @type {(inputs: Ateliere_Connect_Status_Processing_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement du groupe d’événements...`)
};

const de_ateliere_connect_status_processing_event_group = /** @type {(inputs: Ateliere_Connect_Status_Processing_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitung der Ereignisgruppe...`)
};

const it_ateliere_connect_status_processing_event_group = /** @type {(inputs: Ateliere_Connect_Status_Processing_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione del gruppo di eventi in corso...`)
};

const ru_ateliere_connect_status_processing_event_group = /** @type {(inputs: Ateliere_Connect_Status_Processing_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка группы событий...`)
};

const es_ateliere_connect_status_processing_event_group = /** @type {(inputs: Ateliere_Connect_Status_Processing_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando grupo de eventos...`)
};

const zh_cn2_ateliere_connect_status_processing_event_group = /** @type {(inputs: Ateliere_Connect_Status_Processing_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在处理事件组...`)
};

const ja_ateliere_connect_status_processing_event_group = /** @type {(inputs: Ateliere_Connect_Status_Processing_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント グループを処理中...`)
};

const hi_ateliere_connect_status_processing_event_group = /** @type {(inputs: Ateliere_Connect_Status_Processing_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह की प्रक्रिया चल रही है...`)
};

const pt_pt2_ateliere_connect_status_processing_event_group = /** @type {(inputs: Ateliere_Connect_Status_Processing_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processando o grupo de eventos...`)
};

/**
* | output |
* | --- |
* | "Processing Event Group..." |
*
* @param {Ateliere_Connect_Status_Processing_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_processing_event_group = /** @type {((inputs?: Ateliere_Connect_Status_Processing_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Processing_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_processing_event_group(inputs)
	if (locale === "de") return de_ateliere_connect_status_processing_event_group(inputs)
	if (locale === "it") return it_ateliere_connect_status_processing_event_group(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_processing_event_group(inputs)
	if (locale === "es") return es_ateliere_connect_status_processing_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_processing_event_group(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_processing_event_group(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_processing_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_processing_event_group(inputs)
	return en_ateliere_connect_status_processing_event_group(inputs)
});